<template>
  <div class="vgt-global-search vgt-clearfix" style="width: 100%">
    <div class="vgt-global-search__input vgt-pull-right">
      <span class="input__icon ts-cursor-pointer" @click.prevent="onEnter"
        ><div class="magnifying-glass"></div
      ></span>
      <input
        :value="value.search_value"
        @input="updateValue($event.target.value)"
        type="text"
        ref="search_barcode"
        @keypress.enter="onEnter"
        placeholder="Search product(Press F2 move focus)"
        class="vgt-input vgt-pull-right"
      />
      <span class="input__icon ts-cursor-pointer" @click.prevent="onEnter"
        ><div class="magnifying-glass"></div
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({ search_value: '' })
    }
  },
  mounted() {
    // Add event listener with safety check
    window.addEventListener('keydown', this.handleKeyPress);
  },
  beforeDestroy() {
    // Clean up event listener
    window.removeEventListener('keydown', this.handleKeyPress);
  },
  methods: {
    onEnter() {
      this.$emit('onEnter')
    },
    updateValue(searchValue) {
      this.$emit('input', {
        ...this.value,
        search_value: searchValue
      })
    },
    handleKeyPress(e) {
      if (e.keyCode === 113) { // F2 key
        e.preventDefault();
        this.focusSearchInput();
      }
    },
    focusSearchInput() {
      // Use nextTick to ensure the ref is available
      this.$nextTick(() => {
        if (this.$refs.search_barcode) {
          this.$refs.search_barcode.focus();
        }
      });
    }
  }
}
</script>